module.exports = __webpack_public_path__ + "static/img/egg_r_08.7244c0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/r/egg_r_08.png
// module id = qUUj
// module chunks = 1